module.exports = __webpack_public_path__ + "static/media/paidon.8454d73f.svg";